/**
 * Single source of truth for the Toolbox root agent's production model/reasoning-effort
 * defaults (see ChatTab.tsx). Plain string constants, not `Model`/`ReasoningEffort` enum
 * members: eval/eval-lib.mts runs under plain `node` with TypeScript type-stripping, which
 * can't handle real `enum` syntax, so it imports this file directly instead of hardcoding a
 * copy of the values that could drift from what Toolbox actually defaults to.
 */
export const DEFAULT_TOOLBOX_MODEL_VALUE = 'gpt-5.6-luna';
export const DEFAULT_TOOLBOX_REASONING_EFFORT = 'medium';
